import Phaser from 'phaser';

import Hero from '../Hero';
import Ghost from '../Ghost';

import { calculateSpeed, GhostAI } from './GhostAI';
import { tileSize } from '~/src/consts/sizes';

export default class FlankHeroAI implements GhostAI {
	private readonly hero: Hero;
	private readonly ghost: Ghost;
	private readonly chasingGhost: Ghost;
	public speed = 0;

	get targetPosition() {
		return new Phaser.Math.Vector2(this.hero)
			.add(this.hero.facingVector
				.multiply(new Phaser.Math.Vector2(-2 * tileSize)))
			.subtract(new Phaser.Math.Vector2(this.chasingGhost))
			.add(new Phaser.Math.Vector2(this.chasingGhost));
	}

	constructor(hero: Hero, ghost: Ghost, chasingGhost: Ghost) {
		this.hero = hero;
		this.ghost = ghost;
		this.chasingGhost = chasingGhost;
		this.speed = (calculateSpeed(this.ghost.level - 1)) * tileSize;
	}

	chooseTarget() {
		return;
	}
}
